import React, { useEffect, useState } from "react";
import axios from "axios";
import NotFound from "../NotFound/notFound";
import displayToastMessage from "../Alert/displayToastMessage"
import PropTypes from "prop-types";
import useHttp from "../../../hooks/useHttp";
import APIService from "../../../services/apiAxiosService";
function VerifyIdamLogin(props) {
  const [isInvalidAccess, setIsInvalidAccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const { sendRequest: idamLoginAPI } = useHttp();
  const { sendRequest: unitUserListAPI } = useHttp();
  const { sendRequest: idamLoginManagerAPI } = useHttp();

  const redirectBackToLogin = () => {
    // props.history.push("/login");
  };

  const handleLogin = async (data) => {
    let usersList;
    setLoading(true);

    await idamLoginManagerAPI(
      APIService.IdamLoginManager({ ...data }),
      (result) => {},
      (err) => {
        setLoading(false);
        displayToastMessage("Invalid Credentials. Please try again", "error");
      }
    );
    if (sessionStorage.getItem("roleId") != 4) {
      await unitUserListAPI(
        APIService.getAssessmentUnitUserList(),
        (result) => {
          usersList = result;
        },
        (err) => {
          setLoading(false);
          displayToastMessage(
            "Something went wrong. Please try again",
            "error"
          );
        }
      );
      if (usersList.length > 0) {
        sessionStorage.setItem("ongoingAssessment", true);
      }
    }
    setLoading(false);
  };

    const verifyIfUniqueCodeIsValid = async () => {
      // get email and unique code from params
      const { email, uniquecode } = { ...props.match.params };
      // pass email and uniquecode to an api.
      // From it, we can receive if the email and unique code are valid or not.
      const verifyIdamBody = {
        email,
        uniqueCode: uniquecode,
      };

    const res = new Promise((resolve) => {
      idamLoginAPI(
        APIService.verifyIdamLogin({ ...verifyIdamBody }),
        (result, resolve) => {
          var csrf_token = 0;
          if (result.CODE) {
            setLoading(false);
            sessionStorage.setItem("roleId", result.MSG[0]._role_id);
            sessionStorage.setItem("userId", result.MSG[0].userId);
            sessionStorage.setItem("orgId", result.MSG[0]._org_id);
            sessionStorage.setItem("loggedIn", true);
            sessionStorage.setItem("jwtToken", result.MSG[0].jwtToken);
            axios.defaults.headers.common["roleid"] = result.MSG[0]._role_id;
            axios.defaults.headers.common["userid"] = result.MSG[0].userId;
            axios.defaults.headers.common["orgid"] = result.MSG[0]._org_id;

            if (result.MSG[0]._role_id == 6) {
              props.history.push("/admin");
            } else if (result.MSG[0]._role_id == 5) {
              props.history.push("/dashboard");
            } else {
              props.history.push({
                pathname: "/organizations",
                state: { userroles: result.MSG },
              });
            }

            var name = "csrf_token" + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(";");
            for (var i = 0; i < ca.length; i++) {
              var c = ca[i];
              while (c.trim().length === 0) {
                c = c.substring(1);
              }
              if (c.indexOf(name) == 0) {
                csrf_token = c.substring(name.length, c.length);
              }
            }
          } else {
            // displayToastMessage(result.MSG, "error");
            setLoading(false);
            return;
          }
          resolve(result);
        },
        (err) => {
          resolve(err);
        }
      );
    });
    if (res.code) {
      const body = {
        email_id: email,
      };
      handleLogin(body);
    } else {
      redirectBackToLogin();
    }
  }
  useEffect(() => {
    // get email and unique code from params
    const { email, uniquecode } = { ...props.match.params };
    if (email && uniquecode) {
      setIsInvalidAccess(false);
      verifyIfUniqueCodeIsValid();
    } else {
      setIsInvalidAccess(true);
    }
  }, []);

  const displayInvalidAccess = () => {
    if (isInvalidAccess) {
      return <NotFound />;
    }
    return <></>;
  };

  return (
    <div>
      {displayInvalidAccess()}
      {loading && (
        <>
          <span className="a-loading a-primary a-m-10 a-loading-16"></span> Login verification in progress. Please wait...
        </>
      )}
    </div>
  );
}
VerifyIdamLogin.propTypes = {
  history: PropTypes.any,
  match: PropTypes.any
}

export default VerifyIdamLogin;
